export default __webpack_public_path__ + "static/media/Upload.25f53b82.svg";